"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryEventViewModel = void 0;
const index_1 = require("../../Model/Events/index");
const EventBaseViewModel_1 = require("./EventBaseViewModel");
class BoundaryEventViewModel extends EventBaseViewModel_1.EventViewModel {
    constructor(boundaryEvent, processModel) {
        var _a, _b, _c, _d, _e, _f;
        super(boundaryEvent, processModel);
        this.errorName = (_a = boundaryEvent.errorEventDefinition) === null || _a === void 0 ? void 0 : _a.name;
        this.errorCode = (_b = boundaryEvent.errorEventDefinition) === null || _b === void 0 ? void 0 : _b.code;
        this.errorMessage = (_c = boundaryEvent.errorEventDefinition) === null || _c === void 0 ? void 0 : _c.message;
        this.timerType = ((_d = boundaryEvent.timerEventDefinition) === null || _d === void 0 ? void 0 : _d.timerType) ?
            index_1.TimerType[(_e = boundaryEvent.timerEventDefinition) === null || _e === void 0 ? void 0 : _e.timerType] : null;
        this.timerValue = (_f = boundaryEvent.timerEventDefinition) === null || _f === void 0 ? void 0 : _f.value;
    }
}
exports.BoundaryEventViewModel = BoundaryEventViewModel;
//# sourceMappingURL=BoundaryEventViewModel.js.map